<!-- 封装全局计数器 -->
<template>
  <div>
    <!-- <van-stepper
      v-bind="$attrs"
      v-on="$listeners"
      v-model="num"
      :min="min"
      :step="step"
      :max="max"
      @plus="plus"
      @minus="minus"
      class="cc-stepper"
      @overlimit="overlimit"
    />-->
    <div class="stepper">
      <div @click="minus" class="stepper-minus btn"></div>
      <input
        @blur="onBlur"
        type="number"
        v-model="num"
        class="stepper-num"
        @keyup="keyup"
      />
      <div class="stepper-add btn" @click="plus"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Stepper, Toast } from 'vant'
import cartStep from '@/mixins/cartStep'

Vue.use(Stepper).use(Toast)

export default {
  name: 'cc-stepper-new',
  mixins: [cartStep],
  props: {
    /**
     *  值(接收的是父组件中的val值)
     */
    value: {
      type: Number,
      default: 1
    },
    /**
     * 每次加减的大小
     */
    step: {
      type: Number,
      default: 0
    },
    /**
     * 最小值
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * 最大值
     */
    max: {
      type: Number,
      default: 0
    },
    /**
     * 判断是否是散装 0 不支持散装 1 支持散装
     */
    choose: {
      type: Number,
      default: 0
    },
    /**
     * 判断规格是否有误的最小值
     */
    judgeNornSure: {
      type: Number,
      default: 0
    }
  },
  components: {},

  data () {
    return {
      num: this.value * 1
    }
  },

  computed: {},
  created () {},
  methods: {
    plus () {
      // 包装规格是否有误
      var packRrrorRes = this.packRrror(this.choose, this.judgeNornSure)
      if (!packRrrorRes) {
        return false
      }
      let value = null
      value = +this.num + this.step
      if (value > this.max) {
        value = +this.num
        Toast('抱歉，已超过该商品库存量！')
        return false
      }
      this.num = value
      this.sonTofat()
    },
    minus () {
      // 包装规格是否有误
      var packRrrorRes = this.packRrror(this.choose, this.judgeNornSure)
      if (!packRrrorRes) {
        return false
      }
      let value = 0
      value = this.num - this.step
      if (value < this.min) {
        value = this.num
        Toast('抱歉，最小购买量为（' + this.min + '）!')
      }
      this.num = value
      this.sonTofat()
    },
    keyup () {
      if (this.choose === 0) {
        this.num = parseInt(this.num)
      }
    },
    onBlur () {
      if (this.choose === 0) {
        this.num = parseInt(this.num)
      }
      if (+this.num > this.max) {
        Toast('抱歉，已超过该商品库存量！')
        this.num = this.max
      } else if (+this.num === 0) {
        Toast('抱歉，购买量不能小于等于0！')
        this.num = this.step
      }
      this.num = +this.num
      this.sonTofat()
    },
    sonTofat () {
      this.num = this.step === 1 ? this.num : +this.num.toFixed(3)
      this.$emit('input', this.num)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.num = this.value * 1
      }
    },
    num: {
      deep: true,
      immediate: true,
      handler (newValue) {
        // this.$emit('input', this.step === 1 ? this.num : +this.num.toFixed(3))
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.stepper{
  width: 108px;
  height: 24px;
  display: flex;
  .btn{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    box-sizing: border-box;
  }
  &-minus{
    border: 1px solid var(--APP_theme_color);
    background: rgba(255,255,255,1);
    @include center();
    &::before{
      content: '';
      display: inline-block;
      width: 11px;
      height: 2px;
      background: var(--APP_theme_color);
    }
  }
  &-num{
    border: none;
    display: inline-block;
    text-align: center;
    width: 60px;
  }
  &-add{
    border: 1px solid var(--APP_theme_color);
    background: var(--APP_theme_color);
    position: relative;
    /* @include center(); */
    &::before{
      content: '';
      display: inline-block;
      width: 11px;
      height: 2px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

    margin: auto;
      background: rgba(255,255,255,1);
    }
    &::after{
      content: '';
      display: inline-block;
      width: 2px;
      height: 11px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background: rgba(255,255,255,1);
    }
  }
}
.disabled-btn{
  pointer-events: none;
}
</style>
